import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInput, required } from 'react-admin';

const FOLDER_PREFIX =
    '1 - MRT Companies/01-MRT Construction/1. MRT Roofing/5. Roofing Technical Information/Municipalities Roofing Permit Applications';

// Key must match the backend pattern ^[a-z0-9_]+$.
export const municipalityKeyFromName = (name: string): string =>
    name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');

// Mirrors the backend normalize_city_key: lowercase, hyphens -> spaces, collapse
// whitespace. The project city is matched against this to resolve the municipality.
export const municipalityCityKeyFromName = (name: string): string =>
    name.trim().toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ');

// Strip characters OneDrive/SharePoint forbids in a folder name, then append to
// the fixed Municipalities templates path.
export const municipalityFolderFromName = (name: string): string => {
    const clean = name
        .replace(/["*:<>?/\\|]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\.+$/, '');
    return clean ? `${FOLDER_PREFIX}/${clean}` : '';
};

export const MunicipalityInputs = () => {
    const { setValue } = useFormContext();
    // Derive key + OneDrive folder from the name as the user types it.
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.value;
        setValue('key', municipalityKeyFromName(name), { shouldDirty: true });
        setValue('city_key', municipalityCityKeyFromName(name), { shouldDirty: true });
        setValue('onedrive_template_folder', municipalityFolderFromName(name), {
            shouldDirty: true,
        });
    };
    return (
        <>
            <TextInput
                source="name"
                validate={required()}
                fullWidth
                onChange={handleNameChange}
            />
            <TextInput
                source="key"
                validate={required()}
                fullWidth
                helperText="Lowercase a-z, 0-9, underscore"
            />
            <TextInput
                source="folio_prefix"
                label="Folio prefix"
                fullWidth
                helperText="Two digits, e.g. 01 (leave blank if none)"
            />
            <TextInput source="city_key" label="City" fullWidth />
            <TextInput
                source="onedrive_template_folder"
                label="OneDrive template folder"
                fullWidth
            />
            <TextInput
                source="apply_description"
                label="Application description"
                multiline
                rows={4}
                fullWidth
            />
        </>
    );
};
